import {
	Card,
	Radio,
	FormControlLabel,
	styled,
	Stack,
	RadioGroup,
	Typography,
	css,
} from '@mui/material';
import {StyledCardProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	padding: 20px 16px;
	border-radius: 8px;
	box-shadow: none;
	border: 1px solid transparent;

	display: flex;
	flex-direction: column;
	gap: 12px;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 20px 32px;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	${({$isError, theme}) =>
		$isError &&
		css`
			border-color: ${theme.palette.error.main};
		`}
`;

const StyledMotivatorTitle = styled(Typography)`
	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 250px;
	}
`;

const StyledRadioGroup = styled(RadioGroup)`
	flex-direction: row;
	gap: 12px;

	${({theme}) => theme.breakpoints.up('lg')} {
		flex-wrap: nowrap;
		gap: 24px;
	}
`;

const StyledRadio = styled(Radio)`
	position: absolute;
	opacity: 0;
	padding: 0px;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
	position: relative;
	padding: 16px 24px;
	margin: 0px;
	border: 1px solid #c0c0c0;
	border-radius: 4px;
	justify-content: center;
	width: calc(50% - 6px);

	&[data-value='true'] {
		background-color: ${({theme}) => theme.palette.primary.shades?.['12p']};
		border-color: ${({theme}) => theme.palette.primary.main};
	}

	&[data-index='2'] {
		width: 100%;
	}
`;

const StyledLabel = styled(Stack)`
	flex-direction: row;
	gap: 12px;
	align-items: center;
`;

export {
	StyledCard,
	StyledMotivatorTitle,
	StyledRadioGroup,
	StyledRadio,
	StyledFormControlLabel,
	StyledLabel,
};
